export const DEFAULT_TOP_POSITION = 45
export const MIN_MODAL_SPACE = 90
export const SCROLL_OFFSET = 45
export const BOTTOM_SPACING = 20
